export default {
    error: {
        points_program_inactive: "{$0} paused because it uses the \"{$1}\" filter linked to the points program which is disabled. Reactivate the points program or remove the filter before reactivating.",
        points_program_inactive_trigger: "{$0} paused because it uses a trigger linked to the points program which is disabled. Reactivate the points program or change the trigger before reactivating.",
        points_program_inactive_action: "{$0} paused because it has an action linked to the points program which is disabled. Reactivate the points program or remove the action before reactivating.",
        segment_unavailable: "{$0} paused because it uses the \"{$1}\" filter which has errors or is unavailable. Fix the segment or remove the filter before reactivating.",
        generic: "Error activating {$0}. Please contact support if the problem persists.",
        short: {
            points_program_inactive: "Filter unavailable: points program is disabled.",
            points_program_inactive_trigger: "Trigger unavailable: points program is disabled.",
            points_program_inactive_action: "Action unavailable: points program is disabled.",
            segment_unavailable: "Audience unavailable: segment has errors.",
            generic: "Error activating {$0}.",
        },
    },
    action_names: {
        coupon: "coupon",
        feedback_link: "link",
        auth_link: "authentication link",
        notification: "notification",
        add_points: "points",
        data_sets: "data set",
        calculator: "calculator",
    },
    action_alias: {
        notification: "notification",
        coupon: "coupon",
        cashback: "cashback",
        coupon_external: "external_coupon",
        feedback_link: "link",
        add_points: "points",
        auth_link: "login_link",
        task: "task",
        update_field: "update_field",
        web_hook: "webhook",
        ai_content: "ai_content",
        move_client_stage: "move_stage",
        add_to_segment: "add_to_segment",
        remove_from_segment: "remove_from_segment",
        plugin_action: "plugin_action",
        smart_insertion: "insertion",
        remove_smart_insertion: "remove",
        data_sets: "data",
        calculator: "calculator",
        wait: "wait",
        kevichat_internal_chat_create: "open_chat",
        kevichat_internal_chat_message: "post_to_chat",
    },
    triggers: {
        inactivity: "Inactivity",
        new_order: "New order",
        data_filled: "Profile completed",
        reward_reached: "Reward reached",
        feedback_received: "Feedback received",
        specific_date: "Scheduled",
        coupon_expiring: "Coupon expiring",
        birthday: "Birthday",
        too_long_on_external_status: "Stagnant order",
        joined_segment: "Joined segment",
        left_segment: "Left segment",
        periodic: "Periodic",
        custom_event: "Custom event",
        custom_event_without_order: "Custom event without order",
        order_status_changed: "Order status updated",
        reward_used: "Reward used",
        product_group_stock: "Product running out",
        enter_stage: "Entered stage",
        task_moved_to_column: "Task moved to column",
        quotation_status_changed: "Quote status updated",
        new_quotation: "New quote",
        quotation_without_order: "Missed opportunity",
        quotations_too_long_status: "Stagnant quote",
        quotation_expired: "Quote expired",
        client_date: "Client date",
        order_status_change: "Order status updated",
        manual: "Manual trigger",
    },
    goals: {
        orders: "purchase",
        answers: "form response",
        coupons_codes: "coupon redemption",
        rewards_transactions: "reward redemption",
        custom_events: "custom event",
    },
    list: {
        page_title: "Kevi | Marketing Actions",
        page_header: "Marketing Actions",
        add_action_button: "Add Action",
        no_credits_alert:
            "Your credits have run out and your automations are not working.",
        low_credits_alert:
            "Your credits are running low, your automations may stop working soon.",
        confirm_delete_title: 'Are you sure you want to delete <b>"{$0}"</b>?',
        confirm_delete_body: "This automation will stop working once removed.",
        confirm_play_title: 'Are you sure you want to resume <b>"{$0}"</b>?',
        confirm_play_body:
            "Once resumed, the automation will start working again and can be paused at any time.",
        confirm_pause_title: 'Are you sure you want to pause <b>"{$0}"</b>?',
        confirm_pause_body:
            "Once paused, the automation will stop working and can be resumed at any time.",
        confirm_duplicate_title: 'Would you like to duplicate <b>"{$0}"</b>?',
        confirm_duplicate_body:
            "After duplication, the automation will be paused and you will need to adjust the configuration.<br /><br />Do you want to duplicate the automation?",
        confirm_duplicate_campaign_body:
            "To avoid accidental sends, you will need to select a new date for the campaign after duplicating.<br /><br />Would you like to duplicate the campaign?",
        campaign_label: "Campaign",
        automation_label: "Automation",
        messages_label: "messages",
        purchases_label: "purchases",
        answers_label: "answers",
        conversions_label: "conversions",
        play_success: "Action started successfully!",
        pause_success: "Action paused successfully!",
        action_error: "An error occurred while performing this action!",
        duplicate_success: "Automation duplicated successfully!",
        filters: {
            period: "Period",
            title: "Automation title",
            type: "Type",
            type_campaigns: "Campaigns",
            type_automations: "Automations",
            status: "Status",
            status_active: "Active",
            status_paused: "Paused",
            status_deleted: "Deleted",
        },
        aria: {
            edit_automation: "Edit automation {$0}",
            actions_group: "Actions for {$0}",
            duplicate_automation: "Duplicate automation {$0}",
            report_automation: "Automation report {$0}",
            resume_automation: "Resume automation {$0}",
            pause_automation: "Pause automation {$0}",
            remove_automation: "Remove automation {$0}",
        },
        tooltip: {
            duplicate: "Duplicate automation",
            report: "Automation report",
            edit: "Edit automation",
            remove: "Remove automation",
            resume: "Resume automation",
            pause: "Pause automation",
        },
    },
    form: {
        page_title: "Kevi | Automations",
        editing_warning:
            "For your safety, this action will not be executed while you are editing.",
        trigger_points_program_inactive_warning:
            "This automation uses a trigger linked to the points program, which is inactive. For it to work again, reactivate the points program or change the trigger.",
        filter_points_program_inactive_warning:
            "This automation uses the points balance filter, but the points program is disabled. Remove the filter or reactivate the points program to activate this automation.",
        segment_with_error: "with error",
        confirm_overwrite_title:
            '"{$0}" was recently editing this automation and you may overwrite their work.',
        confirm_overwrite_body: "Do you want to continue anyway?",
        confirm_edit_active_title:
            "This campaign has already started, do you still want to change its data?",
        confirm_edit_active_body:
            "After starting, editing it may cause duplicate sends.",
        title_new: "Add",
        title_edit: "Edit",
        title_page_suffix: "Action",
        title_label: "Title",
        title_help: "Choose a title to identify your action",
        goal_label: "Goal",
        goal_help: "What is the goal of this campaign?",
        select: "Select",
        goals: {
            orders: "Generate order",
            answers: "Get feedback",
            custom_event_clients: "Execute custom event",
            loyalty_points_earned: "Earn loyalty points",
            reward_redemptions: "Reward redemption",
        },
        select_option: "Select one of the Options",
        any_option: "Any of the Options",
        conversion_period_help: "What is the conversion period (in days)?",
        zero_days: "0 days",
        trigger_label: "Trigger",
        trigger_help: "Choose the trigger that will start the action",
        triggers: {
            inactivity: "Inactivity",
            new_order: "New order",
            order_status_change: "Order status updated",
            product_group_stock: "Product running out",
            periodic: "Periodic Date",
            too_long_on_external_status: "Stagnant Order",
            client_date: "Client date",
            data_filled: "Profile completed",
            custom_event: "Performed Custom Event",
            custom_event_without_order: "Custom event without order",
            coupon_expiring: "Coupon expiring",
            reward_reached: "Reach reward",
            reward_used: "Reward used",
            feedback_received: "New feedback",
            joined_segment: "Joined segment",
            left_segment: "Left segment",
            enter_stage: "Entered stage",
            task_moved_to_column: "Task moved to column",
            birthday: "Birthday",
            manual: "Manual trigger",
            specific_date: "Campaign",
            new_quotation: "New quote",
            quotation_status_change: "Quote status updated",
            quotations_too_long_status: "Stagnant quote",
            quotation_expired: "Quote expired",
            quotation_without_order: "Missed opportunity",
        },
        action_modal: {
            identification_label: "Identification:",
            identification_help: "Choose an id for this action, what you type here can be used to access properties of this action in future notifications within this same automation.",
            identification_error: "The identification must have a maximum of 25 characters",
            identification_duplicate_error: "Please choose an identification that has not been used yet.",
            cancel_button: "Cancel",
            add_button: "Add",
        },
        add_action_modal_title: "Add Action",
        action_types: {
            generate_coupon: "Generate Coupon",
            generate_coupon_tray: "Generate Coupon on Tray",
            generate_coupon_shopify: "Generate Coupon on Shopify",
            calculate_cashback: "Calculate Cashback",
            generate_feedback_link: "Generate Feedback Link",
            generate_auth_link: "Generate Authentication Link",
            generate_notification: "Generate Notification",
            add_points: "Add Points",
            add_task: "Add Task",
            update_client_field: "Update client info",
            webhook: "WebHook",
            generate_ai_content: "Generate AI content",
            move_client_stage: "Move client in journey",
            add_to_segment: "Add to segment",
            remove_from_segment: "Remove from segment",
            smart_insertion: "Smart Insertion",
            remove_smart_insertion: "Remove Insertion",
            select_data_sets: "Select Data Set",
            calculator: "Calculator",
            wait: "Wait",
            new_notification: "New Notification",
        },
        filter_audience_title: "Filter the action audience",
        audience_label: "Audience:",
        configure_actions_title: "Configure Actions",
        add_button: "Add",
        action_config_help:
            "What actions should be executed when the flow runs?",
        confirm_delete_action_title:
            "Are you sure you want to remove the action {$0}?",
        confirm_delete_action_body:
            "This action will stop working once removed.",
        confirm_save_campaign_title:
            "This campaign will be sent to all your clients.",
        confirm_save_campaign_body: "Are you sure you want to continue?",
        saving: "Saving...",
        save_and_activate: "Save and Activate",
        save_draft: "Save as draft",
        a_user: "A user",
        save_error_message: "Error saving automation.",
        filters: {
            avg_ticket: "Average ticket",
            orders_amount: "Number of orders",
            customer_profile: "Customer profile",
            profile_complete: "With complete registration",
            profile_incomplete: "Without complete registration",
            points_balance: "Points balance",
            client_segments: "Client segment",
            client_segments_not: "Not in segment",
            last_order_period: "Last order period",
            min_period_between_execution: "Minimum time between executions",
            branch: "Branches",
            last_branch: "Branch of last order",
            clients_limit: "Customer limit",
            value: "Value",
            period_between_executions: {
                label: "Days",
                suffix: "days",
                check_label: "Check:",
                check_options: {
                    this: "This automation",
                    all: "Any automation",
                },
                close_button: "Close",
                not_informed: "Not informed",
                check_suffix: {
                    all: " ( all ) ",
                    this: " ( this )",
                },
            },
        },
        actions: {
            auth_link: {
                title: "Generate an authentication link",
                description: "Creates a link that takes the already authenticated client to the client area, where they can consult their points and vouchers.",
            },
            add_points: {
                title: "Add points to the customer",
                description: "This action allows you to add points to the customer's profile where it is executed.",
                points_label: "How many points do you want to add?",
                use_snippets_label: "Use replacement tags in this field",
                snippet_placeholder: "E.g.: [[calculadora.resultado]]",
                snippets_help: "Pick a tag that resolves to a number. The value is rounded and, if it is zero or negative, no points are added:",
            },
            cashback: {
                title: "Calculate Cashback",
                description: "Calculate the cashback value for the customer.",
                percentage_label: "What % of this purchase do you want to return to the customer?",
                max_discount_label: "Maximum discount value in %",
                simulation_button_open: "Close simulation",
                simulation_button_closed: "Simulate cashback",
                example_value_label: "Customer purchase value in $",
                example_text: "Example: If the customer buys <strong>${$0}</strong> they will receive <strong>${$1}</strong> in cashback to use on purchases over <strong>${$2}</strong>",
            },
            coupon: {
                title: "Generate a coupon",
                description: "Create a new discount coupon for the customer.",
                validity_label: "What is the coupon validity?",
                validity_unit: "Days",
                min_wait_label: "Minimum time for use?",
                min_wait_help: "What is the minimum time the customer needs to wait before using this coupon?",
                min_wait_unit: "Hours",
                calculation_label: "How is the coupon value calculated?",
                calculation_options: {
                    fixed_amount: "Fixed amount",
                    percentage: "Percentage discount",
                    cashback: "Cashback",
                    other: "Other",
                },
                discount_label: "What is the coupon discount value?",
                use_snippets_label: "Use replacement tags in this field",
                min_purchase_label: "Minimum purchase value",
                cashback_percentage_label: "What % of this purchase do you want to return to the customer?",
                cashback_max_discount_label: "Maximum discount value in %",
                cashback_example_text: "Example: If the customer buys <strong>${$0}</strong> they will receive <strong>${$1}</strong> in cashback to use on purchases over <strong>${$2}</strong>",
                description_label: "Coupon description for the customer",
                snippets_help: "You can use the following smart replacement tags in your request:",
                token_copied: "Token copied successfully!",
            },
            coupon_external: {
                title: "Generate a coupon",
                description: "{$0} on orders over {$1}",
                validity_label: "What is the coupon validity? (In days)",
                calculation_label: "How is the coupon value calculated?",
                calculation_options: {
                    fixed_amount: "Fixed amount",
                    percentage_amount: "Percentage",
                    cashback: "Cashback",
                },
                fixed_amount_label: "What is the coupon value?",
                percentage_amount_label: "What is the coupon discount?",
                cashback_percentage_label: "What % of this purchase do you want to return to the customer?",
                cashback_max_discount_label: "Maximum discount value in %",
                min_purchase_label: "Minimum purchase value",
                discount_scope_label: "Where does the Shopify discount apply?",
                discount_scope_help: "Order is the default. Product applies only to items and can combine with an order discount.",
                discount_scope_options: {
                    order: "Order discount",
                    product: "Product discount",
                },
            },
            task: {
                title: "Generate a task for the team",
                description: "Create a new task for a team member to perform.",
                snippets_help: "You can use the following smart replacement tags in all task fields:",
                board_label: "In which board?",
                board_placeholder: "Select a board",
                task_title_label: "Task title",
                deadline_label: "Task deadline (in days)",
                description_label: "Description",
                has_message_suggestion_label: "Add message suggestion",
                use_ai_label: "Use AI to generate message",
                message_suggestion_label: "Message Suggestion",
                ai_prompt_label: "Explain how the message should be.",
                ai_prompt_help: "The suggested message will be generated using artificial intelligence. We will feed the AI with the customer's purchase history and customer data.",
                responsible_label: "Responsible",
                responsible_help: "Who should be responsible for the task?",
                assign_methods: {
                    manual: "Select manually",
                    by_role: "Distribute by role",
                    by_custom_field: "Customer field",
                },
                role_label: "Role",
                role_placeholder: "Select role",
                branch_label: "Branch",
                branch_rules: {
                    last: "Last visited",
                    first: "First visited",
                    all: "All",
                },
                custom_field_label: "Customer field",
                custom_field_placeholder: "Select customer field",
                user_label: "User",
                user_placeholder: "Select user",
                token_copied: "Token copied successfully!",
            },
            update_field: {
                title: "Update customer fields",
                description: "Dynamically update customer information.",
                snippets_help: "You can use the following smart replacement tags in the fields:",
                field_label: "Which field do you want to update?",
                field_placeholder: "Select the field",
                update_rule_label: "How to update?",
                update_rules: {
                    always_replace: "Always replace",
                    set_if_empty: "Fill if empty",
                },
                fill_rule_distribute: "Distribute by role",
                fill_rule_order_field: "Fill with order field",
                fill_rule_manual: "Enter manually",
                distribute_help: "The user will be randomly selected according to the filters below:",
                branch_label: "Branch",
                branch_placeholder: "Select an option",
                branch_options: {
                    any: "Any",
                    last: "Last order branch",
                    first: "First order branch",
                },
                role_label: "Role",
                role_placeholder: "Select an option",
                role_any: "Any",
                select_option_placeholder: "Select an option",
                value_label: "What is the value?",
                add_field_button: "Add Field",
                token_copied: "Token copied successfully!",
                user_manual_label: "Which user?",
                user_manual_help: "Enter a user ID or email, or a replacement tag that results in one of them. If the value does not match an active user, the step fails.",
                user_manual_pick_user: "Or pick a user to fill in the ID",
            },
            web_hook: {
                title: "Execute WebHook",
                description: "This action makes a POST call to the reported URL.",
                url_label: "Which URL do you want to call?",
                request_body_title: "Request body",
                field_key_label: "Field (key)",
                field_key_placeholder: "Ex: name",
                field_value_label: "Value",
                field_value_placeholder: "Ex: [[customer.name]]",
                add_field_button: "Add field",
            },
            ai_content: {
                title: "Generate content with AI",
                description: "This action allows you to generate content automatically with artificial intelligence.",
                model_label: "Which artificial intelligence model do you want to use?",
                models: {
                    basic: "Basic (Recommended)",
                    advanced: "Advanced",
                },
                credits_label: "Credits: {$0}",
                basic_description: "<strong>Basic:</strong> Suitable for most scenarios, but may struggle with complex instructions. Higher risk of hallucination.",
                advanced_description: "<strong>Advanced:</strong> A more accurate model, capable of following complex instructions with less hallucination. Allows returning multiple values (e.g., message, image, coupon) for use in subsequent automation actions. However, the cost per execution is higher. We recommend using it only when the basic model does not yield suitable results.",
                prompt_label: "What do you need? (Prompt)",
                prompt_help: "Describe the content you would like as if you were asking an employee who knows the entire history of this customer.",
                placeholder: "Ex: Write a message to [[customer.name]] offering 10% discount with code [[coupon.discount_code]]. Introduce yourself as John from Company X. Use a friendly and close tone.",
                snippets_help: "You can use the following smart replacement tags in your request:",
                footer_help: "In addition to using the above tokens, your request will be fed with customer data, purchase history, and feedback.",
                advanced_settings_label: "Advanced settings",
                output_values_label: "Additional output values",
                output_values_help: "Define extra fields the AI should return in addition to the main content. Each field will be available as a token in subsequent automation actions. E.g., image URL, coupon code, etc.",
                field_id_placeholder: "Identifier (e.g., image)",
                field_instruction_placeholder: "Instruction for the AI (e.g., product image URL)",
                remove_field_title: "Remove field",
                add_field_button: "Add field",
            },
            move_client_stage: {
                title: "Move customer in the journey",
                description: "To which stage should we move the customer?",
            },
            segment_membership: {
                segment_label: "Segment:",
                segment_placeholder: "Select a segment",
                loading_segments: "Loading segments...",
            },
            add_to_segment: {
                title: "Add to segment",
                description: "Which manual segment should this client be added to?",
            },
            remove_from_segment: {
                title: "Remove from segment",
                description: "Which manual segment should this client be removed from?",
            },
            smart_insertion: {
                title: "Smart insertion",
                description: "This action allows you to execute a smart insertion in the customer's profile.",
                insertion_name_label: "Insertion name",
                insertion_name_help: "The insertion name is used to identify the insertion when disabling it programmatically. You can use replacement tokens in the name.",
                space_label: "Where do you want to make the insertion?",
                duration_label: "Duration (days)",
                edit_html_button: "Edit HTML",
            },
            remove_smart_insertion: {
                title: "Remove smart insertion",
                description: "This action allows you to remove a smart insertion from the customer's profile.",
                space_label: "From where do you want to make the insertion?",
                space_options_any: "Anywhere",
                insertion_name_label: "Insertion name",
                insertion_name_help: "The insertion name is used to identify the insertion when disabling it programmatically. You can use replacement tokens in the name.",
            },
            data_sets: {
                title: "Select Data Set",
                description: "This action allows you to create snippets from data in your Data Set.",
                dataset_label: "Which Data Set do you want to use?",
                selection_mode_label: "How do you want to select the key?",
                selection_modes: {
                    ai: "Select with AI",
                    manual: "Enter manually",
                },
                key_label: "Which key do you want to consult?",
                snippets_help: "You can use the following smart replacement tags in key construction:",
                ai_credits: "Credits: {$0}",
                ai_prompt_label: "Instruction for AI to select the key:",
                ai_prompt_placeholder: "Enter the criteria for the AI to select the most appropriate key...",
                ai_prompt_help: "The AI will analyze the customer data and the data set to select the most appropriate key based on the instruction.",
            },
            wait: {
                title: "Wait",
                description: "Pause the automation for a specified amount of time before continuing to the next action.",
                duration_label: "How long to wait?",
                duration_help: "The automation will pause for this amount of time before executing the next action.",
                days: "Days",
                hours: "Hours",
                minutes: "Minutes",
            },
            calculator: {
                title: "Calculator",
                description: "Calculate a value from a formula using automation data. The result is available to the next actions.",
                formula_label: "Math formula",
                syntax_valid: "Valid syntax",
                syntax_error: "Syntax error",
                insert: "Insert:",
                formula_placeholder: "E.g.: (a + b) * 0.10",
                help_operators: "Available operators:",
                help_decimals: "Use a dot for decimals (e.g.: 10.5).",
                help_functions: "Functions take their values inside parentheses, separated by commas. E.g.:",
                fn_max: "Largest value among the arguments",
                fn_min: "Smallest value among the arguments",
                fn_round: "Rounds to the nearest integer",
                fn_abs: "Absolute value (no sign)",
                fn_floor: "Rounds down",
                fn_ceil: "Rounds up",
                open_parenthesis: "Open parenthesis",
                close_parenthesis: "Close parenthesis",
                variables_label: "Variable mapping",
                variables_empty: "Type a formula with letters to configure the variables. E.g.:",
                mapping_label: "Map to system variable",
                mapping_placeholder: "E.g.: [[pedido.{$0}]]",
                mapping_invalid: "Required format:",
                example_label: "Test value",
                preview_title: "Simulation preview",
                interpretation: "Interpretation:",
                waiting_formula: "Waiting for formula...",
                result_label: "Calculated result:",
                error: "Error",
                error_invalid_result: "Invalid result (division by zero or undefined).",
                error_syntax: "Syntax error. Check parentheses and operators.",
                error_decimal_comma: "Use a dot for decimals (e.g. 0.5). Commas only separate values inside functions, like max(a, b).",
            },
            feedback_link: {
                title: "Generate a link for form",
                description: "Create a new unique link for the customer to send their opinion.",
                form_label: "Form:",
                form_error: "Please select a form.",
                form_help: "Choose one for this action, the form you select here will be used to generate a link to be sent in this same automation, and your customers will answer the questions contained in it.<br />Only forms containing questions will be listed.",
                select_form_placeholder: "Select a Form",
            },
            plugin: {
                use_snippets_label: "Use replacement tags in this field",
                select_placeholder: "Select",
                select_parent_first: "Choose the field above first",
                select_empty: "Nothing found",
                snippets_help: "You can use the following smart replacement tags:",
                token_copied: "Token copied successfully!",
            },
            notification: {
                title: "Send notification",
                description: "Sends a notification to the customer via SMS, email or WhatsApp.",
                content_label: "Content",
                schedule_label: "Shipping times:",
                schedule_help: "Whether or not to respect the time settings defined in the <a href='/#/notification-schedule' target='_blank'>Settings > Notification Shipping Times</a> menu",
                schedule_options: {
                    from_place: "Respect time settings",
                    anytime: "Send anytime",
                },
                timeout_label: "Wait:",
                timeout_help: "How long to wait after the previous action to send this notification? (In minutes)",
                timeout_placeholder: "Ex: 10",
                method_label: "Send via?",
                method_help: "If the email method is chosen and the customer does not have an email configured, the notification will not be sent.",
                method_placeholder: "Select method",
                recipient_label: "Send to:",
                recipient_help: "By default the notification is sent to the customer's own contact. Choose \"Other\" to send to a fixed address or one defined by replacement tags.",
                recipient_options: {
                    client_phone: "Customer's phone",
                    client_email: "Customer's email",
                    custom_phone: "Another phone",
                    custom_email: "Another email",
                },
                recipient_address_label_phone: "Destination phone:",
                recipient_address_label_email: "Destination email:",
                recipient_address_placeholder_phone: "Ex: +5511999999999 or [[cliente.telefone]]",
                recipient_address_placeholder_email: "Ex: contact@company.com or [[cliente.email]]",
                recipient_address_help: "You can use the replacement tags listed below. If the final value is empty, the notification will not be sent.",
                recipient_address_required_error: "Please enter the destination address.",
                sender_label: "Trigger by:",
                sender_placeholder: "Select trigger",
                sender_default: "Default Trigger",
                no_default_sender: "None configured",
                no_default_sender_warning: "No default trigger configured. Click the tag icon next to the trigger to ",
                configure_default_sender_link: "set a default trigger",
                template_placeholder: "Select template",
                wpp_cloud: {
                    header: "Header:",
                    image_preview: "Example image preview:",
                    image_url_label: "{$0} - Image URL:",
                    header_preview_video: "Example video preview:",
                    header_preview_document: "Document header (template example):",
                    header_preview_gif: "Example GIF preview:",
                    header_media_url_video: "{$0} - Video URL:",
                    header_media_url_document: "{$0} - Document URL:",
                    header_media_url_gif: "{$0} - GIF URL:",
                    header_document_example_hint:
                        "This template uses a document in the header. Use a public https:// link, a known file extension (e.g. PDF), or a smart tag. No visual preview is shown.",
                    document_url_accepted_hint:
                        "URL accepted for sending. WhatsApp will use this link as the document header media.",
                    document_filename_label: "File name (optional)",
                    document_filename_help:
                        "Optional display name for the file on the recipient's device. Leave empty to use the default from the link.",
                    document_filename_placeholder: "e.g. invoice.pdf",
                    invalid_document_url_error:
                        "Enter a valid http(s) URL or a link whose path ends with a known document extension (e.g. .pdf).",
                    location_header_label: "Location (header)",
                    location_latitude_label: "Latitude",
                    location_latitude_placeholder: "e.g. -23.5505",
                    location_longitude_label: "Longitude",
                    location_longitude_placeholder: "e.g. -46.6333",
                    location_name_label: "Location name",
                    location_name_placeholder: "e.g. Store downtown",
                    location_address_label: "Address",
                    location_address_placeholder: "Full address",
                    upload_button: "Upload here",
                    validating_media: "Validating media...",
                    custom_media_preview: "Preview of your {$0}:",
                    media_types: {
                        image: "image",
                        video: "video",
                        document: "document",
                    },
                    required_error: "This field must be filled in",
                    video_not_supported: "Your browser does not support the video element.",
                    body: "Body:",
                    body_help: "The message content is fixed for each template, but you can fill in the variables below:",
                    footer: "Footer:",
                    buttons: "Buttons:",
                    buttons_label: "Button ({$0}):",
                    quick_reply: "Quick reply: {$0}",
                    call_phone: "Call phone: {$0} ({$1})",
                    visit_website: "Visit website: {$0} ({$1})",
                    marketing_opt_out: "Marketing Opt-Out: {$0}",
                    coupon_code: "Coupon code: {$0}",
                    invalid_video_error: "Invalid video URL or video not found",
                    invalid_image_error: "Invalid URL or image not found",
                    timeout_video_error: "Timeout: assuming valid video URL",
                    timeout_url_error: "Timeout: assuming valid URL",
                    url_empty_error: "Empty URL",
                    smart_tag_valid_success: "Smart replacement tag identified successfully",
                    smart_tag_not_found_error: "Smart replacement tag not found in the list of available tokens",
                    statuses: {
                        approved: "Approved",
                        rejected: "Rejected",
                        pending: "Pending",
                    },
                },
                whatsapp: {
                    sender_number_label: "Send by which number?",
                    selection_help: "Choose a specific WhatsApp sender, use the client field, or use the last visited branch.",
                    select_manually: "Select manually",
                    instance_placeholder: "Select an instance",
                    client_field: "Client field",
                    select_client_field: "Select client field",
                    custom_field_fallback_help: "Note: if the user returned by this field does not have a linked WhatsApp sender, the Default Trigger will be used.",
                    last_branch: "Last branch visited",
                    last_branch_fallback_help: "Note: if the last visited branch does not have a linked WhatsApp sender, the Default Trigger will be used.",
                    message_placeholder: "Message",
                    send_file_label: "Send file, photo or video.",
                    file_url_placeholder: "File/video URL",
                    upload_help: "Upload here",
                    validating_media: "Validating media...",
                    preview_label: "Preview {$0}:",
                    media_types: {
                        image: "of your image",
                        video: "of your video",
                    },
                    video_not_supported: "Your browser does not support the video element.",
                    required_error: "This field must be filled in",
                    file_url_limit_error: "The file URL cannot be longer than 240 characters",
                },
                email: {
                    subject_label: "Email subject:",
                    subject_placeholder: "Subject",
                    content_label: "Email content:",
                    edit_content_button: "Edit content",
                    edit_html_button: "Edit HTML",
                },
                sms: {
                    accents_help: "*All accents will be removed.",
                },
                rcs: {
                    type_label: "RCS message type",
                    type: {
                        basic: "Short text",
                        single: "Text (up to 1000 characters)",
                        card: "Card",
                        carousel: "Carousel",
                        file: "File",
                    },
                    text_help: "RCS keeps accents. Short text uses the basic route; longer text uses single.",
                    image: "Public image URL",
                    title: "Title",
                    message: "Message",
                    button: "Button",
                    button_text: "Button text",
                    button_url: "Button URL (optional)",
                    add_button: "Add button",
                    button_text_required: "A button with a link needs a label. Without the label, the link is not sent.",
                    card: "Card",
                    add_card: "Add card",
                    file: "Public file URL",
                    file_name: "File name",
                },
                common: {
                    snippets_help: "You can use the following smart replacement tags in the content:",
                    token_copied: "Token copied successfully!",
                },
            },
        },
        triggers_config: {
            birthday: {
                description: "This trigger will be fired when a customer is about to have a birthday.",
                threshold_label: "Execute how many days before your birthday? (Leave 0 to send on birthday)",
            },
            client_date: {
                description: "This trigger is fired based on the date of a customer field.",
                field_label: "What is the date field?",
                field_placeholder: "Select the field",
                when_options: {
                    before: "Send before {$0}",
                    after: "Send after {$0}",
                    at_date: "Send on the exact day of {$0}",
                },
                threshold_label: "How many days {$0} {$1}?",
                threshold_options: {
                    before: "before",
                    after: "after",
                },
                yearly_label: "Send annually on the same date (ideal for birthdays)",
            },
            coupon_expiring: {
                description: "This trigger will be fired when a coupon is about to expire.",
                threshold_label: "Execute how many days before expiring?",
            },
            data_filled: {
                description: "This trigger will be fired when your customers fill in their details.",
            },
            enter_stage: {
                description: "This automation will be triggered when the customer enters the selected stage or some child stage.",
                modal_title: "Move to which stage?",
                close_button: "Close",
                select_stage_button: "Select stage",
            },
            task_moved_to_column: {
                description:
                    "This automation will be triggered when a task is moved into one of the selected board columns.",
                board_label: "Which board?",
                board_placeholder: "Select the board",
                column_label: "Destination column(s)",
                no_columns: "This board has no columns.",
            },
            feedback_received: {
                description: "This trigger will be fired when your customers fill out a feedback form.",
                form_label: "Which Form?",
                all_forms: "All",
                when_label: "When to execute?",
                when_options: {
                    all: "In all feedback",
                    greater: "With an average above x",
                    lower: "With an average below x",
                },
                x_label: "X = ?",
                greater_help: "At what average above do you want to run this automation for feedback?",
                lower_help: "At what average below do you want to run this automation for feedback?",
            },
            inactivity: {
                description: "This trigger will be fired when your customers stay for a period x without placing orders.",
                days_label: "Time without orders (in days):",
            },
            joined_segment: {
                description: "This trigger will be fired when your customers become part of a new segment.",
                segment_label: "Which segment?",
                segment_placeholder: "Select the segment",
                loading_segments: "Loading segments...",
            },
            left_segment: {
                description: "This trigger will be fired when your customers stop being part of a segment.",
                segment_label: "Which segment?",
                segment_placeholder: "Select the segment",
                loading_segments: "Loading segments...",
            },
            manual: {
                description: "This trigger is fired manually from the client screen or through an API request.",
                fields_label: "Trigger fields",
                fields_help: "Each field becomes an item on the client screen form and a snippet you can use in the actions. Use only lowercase letters, numbers and _.",
                name_placeholder: "field_name",
                types: {
                    text: "Text",
                    number: "Number",
                    date: "Date",
                    boolean: "Yes/No",
                },
                required_label: "Required",
                add_field_button: "Add field",
                remove_field_title: "Remove field",
                copy_snippet_title: "Copy snippet",
                api_title: "Fire through the API",
                api_unsaved: "Save the automation to see the API instructions with its ID.",
                api_help: "Authenticate with your integration Bearer token. The client is identified by id, email, phone or name, and will be created if it does not exist.",
                api_docs_link: "View full documentation",
                api_copy_button: "Copy example",
                error_key_required: "Inform the field name.",
                error_key_duplicated: "This name is already used by another field.",
            },
            new_order: {
                description: "This trigger will be fired when your customers make a new order.",
                when_label: "When to execute?",
                when_options: {
                    all: "In all orders",
                    every: "Every x orders",
                    greater: "Every order after x",
                    lower: "Every order before x",
                    exact: "On order number x",
                },
                x_label: "X = ?",
                every_help: "Every how many orders do you want to run this automation?",
                exact_help: "In which order do you want to perform this action? 1? 5?",
                filter_value_label: "Filter orders by value.",
                min_value_label: "Minimum Value",
                max_value_label: "Maximum Value",
                filter_field_label: "Filter orders by {$0}.",
                checkbox_tooltip: "One or more apply.",
                placeholder_equal: "When it is equal to...",
            },
            new_quotation: {
                description: "This trigger will be fired when a new quotation is created.",
                when_label: "When to execute?",
                when_options: {
                    all: "In all quotations",
                    every: "Every x quotations",
                    greater: "Every quotation after x",
                    lower: "Every quotation before x",
                    exact: "On quotation number x",
                },
                x_label: "X = ?",
                every_help: "Every how many quotations do you want to run this automation?",
                exact_help: "In which quotation do you want to perform this action? 1? 5?",
                filter_value_label: "Filter quotations by value.",
                min_value_label: "Minimum Value",
                max_value_label: "Maximum Value",
                filter_field_label: "Filter quotations by {$0}.",
                placeholder_equal: "When it is equal to...",
            },
            order_status_change: {
                description: "This trigger will be fired when an order has its status changed.",
                status_label: "In which status to execute?",
                all_status: "In all status",
                filter_value_label: "Filter orders by value.",
                min_value_label: "Minimum Value",
                max_value_label: "Maximum Value",
                filter_field_label: "Filter orders by {$0}.",
                placeholder_value: "Value...",
                filter_options: {
                    equals: "When it is equal to...",
                    contains: "When it contains...",
                    not_contains: "When it does not contain...",
                    any_value: "When value exists",
                    no_value: "When value does not exist",
                },
            },
            periodic: {
                description: "This trigger will be fired in periodic cycles.",
                send_monthly: "Send monthly",
                send_weekly: "Send weekly",
                at_label: "at",
                week_days: {
                    mon: "Mon",
                    tue: "Tue",
                    wed: "Wed",
                    thu: "Thu",
                    fri: "Fri",
                    sat: "Sat",
                    sun: "Sun",
                },
            },
            product_group_stock: {
                description: "This trigger will be fired when the stock of a product group of your customer is about to run out.",
                group_label: "Which product group?",
                group_placeholder: "Select the product group",
                any_group: "Any group",
                loading_groups: "Loading groups...",
                threshold_label: "Run how many days before the stock runs out? (Leave 0 to send on the day it runs out)",
            },
            quotation_expired: {
                description: "This trigger is fired based on the expiration date of open quotations.",
                when_options: {
                    before: "Send before the expiration date",
                    after: "Send after the expiration date",
                    at_date: "Send on the exact day of the expiration date",
                },
                threshold_label: "How many days {$0} the expiration date ?",
                threshold_options: {
                    before: "before",
                    after: "after",
                },
            },
            quotation_status_change: {
                description: "This trigger will be fired when a quotation has its status changed.",
                status_label: "In which status to execute?",
                all_status: "In all status",
                filter_value_label: "Filter quotations by value.",
                min_value_label: "Minimum Value",
                max_value_label: "Maximum Value",
                filter_field_label: "Filter quotations by {$0}.",
                placeholder_equal: "When it is equal to...",
            },
            quotation_without_order: {
                description: "This trigger will be fired when a customer has a quotation, with no order after it.",
                time_label: "Exactly how long ago?",
                time_placeholder: "Ex: 7",
                unit_label: "Unit",
                units: {
                    days: "Days",
                    hours: "Hours",
                    minutes: "Minutes",
                },
                status_label: "With which quotation status?",
                all_status: "All status",
            },
            quotations_too_long_status: {
                description: "This trigger will be fired when a customer has a quotation stalled in a certain status for more than x days.",
                status_label: "What is the status?",
                days_label: "Stalled for how many days?",
                no_status_help: "You need to register the external status to configure this trigger.",
            },
            reward_reached: {
                description: "This trigger will be fired when your customers reach the points needed to redeem a reward.",
            },
            reward_used: {
                description: "This trigger will be fired when your customers use a specific reward.",
                reward_label: "Which Reward?",
                any_reward: "Any one",
            },
            specific_date: {
                description: "This automation will be fired when the date corresponds to your scheduling settings.",
                date_label: "Date and time:",
            },
            too_long_on_status: {
                description: "This trigger will be fired when a customer has an order stalled in a certain status for more than x days.",
                status_label: "What is the status?",
                days_label: "Stalled for how many days?",
                filter_orders_label: "Filter orders by {$0}.",
                filter_types: {
                    equals: "When it is equal to...",
                    contains: "When it contains...",
                    not_contains: "When it does not contain...",
                    any_value: "When value exists",
                    no_value: "When value does not exist",
                },
                value_placeholder: "Value...",
                no_event_help: "You need to register the custom events to configure this trigger.",
            },
            custom_event: {
                description: "This trigger will be fired when your customers perform a custom event.",
                event_label: "Which event?",
                event_placeholder: "Search event...",
                when_label: "When to execute?",
                when_options: {
                    all: "In all executions",
                    every: "Every x executions",
                    exact: "In execution number x",
                },
                x_label: "X = ?",
                every_help: "Every how many executions do you want to perform this automation?",
                exact_help: "In which execution do you want to perform this action? 1? 5?",
            },
            custom_event_without_order: {
                description: "This trigger will be fired when a customer's latest matching custom event (for example, a product page view) is older than the configured time and no order was placed after it.",
                match_label: "How to match the event?",
                match_options: {
                    exact: "A specific custom event",
                    starts_with: "Event title starts with",
                    contains: "Event title contains",
                },
                event_label: "Which event?",
                event_placeholder: "Search event...",
                title_label: "Event title",
                title_placeholder: "Ex: Entrou no site - https://loja.com/produto",
                title_help: "Matches page-view events by their title. Use a product page URL or path fragment.",
                time_label: "Exactly how long ago?",
                time_placeholder: "Ex: 2",
                unit_label: "Unit",
                units: {
                    days: "Days",
                    hours: "Hours",
                    minutes: "Minutes",
                },
                cooldown_note: "This trigger runs at most once per customer every 24 hours.",
            },
        },
    },
    reach_report: {
        title: "RFM Analysis",
        frequency_monetary_axis: "Average between frequency and monetary value",
        recency_axis: "Recency",
        last_purchase_label: "Last purchase",
        to: "to",
        purchases: "purchases",
        made_in_last_days: "Made in the last {$0} days",
        spent_range: "${$0} to ${$1}",
        spent_in_last_days: "Spent in the last {$0} days",
        col_client: "Client",
        col_phone: "Phone",
        col_email: "E-mail",
        col_recency: "Recency",
        col_frequency: "Frequency",
        col_monetary: "Monetary",
        col_rfm_score: "RFM Score",
    },
    report: {
        created_at: "CREATION DATE:",
        reactivated: "reactivated",
        reactivated_tooltip_part1: "An inactive client is a client who has been more than 60 days without purchasing.",
        reactivated_tooltip_part2: "That is, {$0} clients had been more than 60 days without purchasing and made a purchase after receiving this automation.",
        converted_clients_label: "Converted clients",
        conversions_label: "Conversions",
        financial_return_label: "Financial return",
        avg_ticket_label: "Average ticket",
        conversion_rate_label: "Conversion rate",
        table_title: "Converted clients",
        col_name: "Name",
        col_receipt_date: "Receipt date",
        col_order_date: "Order date",
        col_value: "Value",
        col_days_since_prev: "Days since previous order",
        col_orders_after: "Orders after automation",
        unidentified: "(Unidentified)",
        chart_same_day: "Same day",
        chart_one_day_after: "1 day later",
        chart_n_days_after: "{$0} days later",
        chart_orders_label: "Orders after receiving the automation",
    },
};
